/* eslint-disable */

/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 */

;(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  }
  else if (jQuery && !jQuery.fn.hoverIntent) {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  // default configuration values
  var _cfg = {
    interval: 100,
    sensitivity: 6,
    timeout: 0
  };

  // counter used to generate an ID for each instance
  var INSTANCE_COUNT = 0;

  // current X and Y position of mouse, updated during mousemove tracking
  // (shared across instances)
  var cX, cY;

  // saves the current pointer position coordinates based on the given
  // mousemove event
  var track = function (ev) {
    cX = ev.pageX;
    cY = ev.pageY;
  };

  // compares current and previous mouse positions
  var compare = function (ev, $el, s, cfg) {
    // compare mouse positions to see if pointer has slowed enough to trigger
    // `over` function
    if (Math.sqrt((s.pX - cX) * (s.pX - cX) + (s.pY - cY) * (s.pY - cY)) < cfg.sensitivity) {
      $el.off(s.event, track);
      delete s.timeoutId;
      // set hoverIntent state as active for this element (permits `out`
      // handler to trigger)
      s.isActive = true;
      // overwrite old mouseenter event coordinates with most recent pointer
      // position
      ev.pageX = cX;
      ev.pageY = cY;
      // clear coordinate data from state object
      delete s.pX;
      delete s.pY;
      return cfg.over.apply($el[0], [ev]);
    }
    else {
      // set previous coordinates for next comparison
      s.pX = cX;
      s.pY = cY;
      // use self-calling timeout, guarantees intervals are spaced out properly
      // (avoids JavaScript timer bugs)
      s.timeoutId = setTimeout(function () {
        compare(ev, $el, s, cfg);
      }, cfg.interval);
    }
  };

  // triggers given `out` function at configured `timeout` after a mouseleave
  // and clears state
  var delay = function (ev, $el, s, out) {
    delete $el.data('hoverIntent')[s.id];
    return out.apply($el[0], [ev]);
  };

  $.fn.hoverIntent = function (handlerIn, handlerOut, selector) {
    // instance ID, used as a key to store and retrieve state information on an
    // element
    var instanceId = INSTANCE_COUNT++;

    // extend the default configuration and parse parameters
    var cfg = $.extend({}, _cfg);
    if ($.isPlainObject(handlerIn)) {
      cfg = $.extend(cfg, handlerIn);
      if (!$.isFunction(cfg.out)) {
        cfg.out = cfg.over;
      }
    }
    else if ($.isFunction(handlerOut)) {
      cfg = $.extend(cfg, {
        over: handlerIn,
        out: handlerOut,
        selector: selector
      });
    }
    else {
      cfg = $.extend(cfg, {
        over: handlerIn,
        out: handlerIn,
        selector: handlerOut
      });
    }

    // A private function for handling mouse 'hovering'
    var handleHover = function (e) {
      // cloned event to pass to handlers (copy required for event object to be
      // passed in IE)
      var ev = $.extend({}, e);

      // the current target of the mouse event, wrapped in a jQuery object
      var $el = $(this);

      // read hoverIntent data from element (or initialize if not present)
      var hoverIntentData = $el.data('hoverIntent');
      if (!hoverIntentData) {
        $el.data('hoverIntent', (hoverIntentData = {}));
      }

      // read per-instance state from element (or initialize if not present)
      var state = hoverIntentData[instanceId];
      if (!state) {
        hoverIntentData[instanceId] = state = {id: instanceId};
      }

      // state properties:
      // id = instance ID, used to clean up data
      // timeoutId = timeout ID, reused for tracking mouse position and
      // delaying "out" handler isActive = plugin state, true after `over` is
      // called just until `out` is called pX, pY = previously-measured pointer
      // coordinates, updated at each polling interval event = string
      // representing the namespaced event used for mouse tracking

      // clear any existing timeout
      if (state.timeoutId) {
        state.timeoutId = clearTimeout(state.timeoutId);
      }

      // namespaced event used to register and unregister mousemove tracking
      var mousemove = state.event = 'mousemove.hoverIntent.hoverIntent' + instanceId;

      // handle the event, based on its type
      if (e.type === 'mouseenter') {
        // do nothing if already active
        if (state.isActive) {
          return;
        }
        // set "previous" X and Y position based on initial entry point
        state.pX = ev.pageX;
        state.pY = ev.pageY;
        // update "current" X and Y position based on mousemove
        $el.off(mousemove, track).on(mousemove, track);
        // start polling interval (self-calling timeout) to compare mouse
        // coordinates over time
        state.timeoutId = setTimeout(function () {
          compare(ev, $el, state, cfg);
        }, cfg.interval);
      }
      else { // "mouseleave"
        // do nothing if not already active
        if (!state.isActive) {
          return;
        }
        // unbind expensive mousemove event
        $el.off(mousemove, track);
        // if hoverIntent state is true, then call the mouseOut function after
        // the specified delay
        state.timeoutId = setTimeout(function () {
          delay(ev, $el, state, cfg.out);
        }, cfg.timeout);
      }
    };

    // listen for mouseenter and mouseleave
    return this.on({
      'mouseenter.hoverIntent': handleHover,
      'mouseleave.hoverIntent': handleHover
    }, cfg.selector);
  };
});
/* eslint-enable */

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  jQuery.extend(jQuery.expr[':'], {
    focusable: function (el, index, selector) {
      return $(el).is('a, button, :input, [tabindex]');
    }
  });

  var windowWidth;

  var imgpath = '/themes/custom/tnvacation/img/nav-bg/';

  /** CLICK ELEMENTS **/
  var $navToggle = $('#nav-toggle');
  var $utilityLinks = $('#block-utilitymenucontainer .menu-item a');
  var $mainLinks = $('#block-tnvacation-main-menu .menu-item a');
  var $firstFocusableContentElement = $('#content').find(':focusable').first();

  /** DOM ELEMENTS **/
  var $body = $('body');
  var $header;
  if ($('#site-header').length) {
    $header = $('#site-header');
  }
  else if ($('#kr-header').length) {
    $header = $('#kr-header');
  }
  var $mainNav = $('#block-tnvacation-main-menu');
  var $utilityNav = $('#block-utilitymenucontainer');
  var $topNavLinks = $('#site-header #block-tnvacation-main-menu .menu-item a, #site-header #block-utilitymenucontainer .menu-item a, #site-header #block-utilitymenucontainer .menu-item button');
  var megaMenuBlock = '.block-mega-menu';
  var $megaMenuLink = $('.js-mega-menu-link');
  var $mmCityRegion = $('#block-megamenuforcitiesregions');
  var $mmExperience = $('#block-megamenuforexperiences');
  var $mmTripPlanner = $('#block-megamenufortripplanner');
  var $navCityRegion = $('.nav-cities-regions');
  var $navExperience = $('.nav-experiences');
  var $navTripPlanner = $('.nav-trip-planner');

  var lastScrollTop = 0;
  var navOffset = 0;
  var navHeight = 0;
  var navDelta = navOffset + navHeight;
  var navHover = false;
  var megaMenuHover = false;

  // Keys
  var tabKey = 'Tab';
  var enterKey = 'Enter';

  /** Document Ready **/

  $(document).ready(function () {
    $('.menu-item__no-dropdown').on('mouseover', function () {
      $topNavLinks.removeClass('active-nav');
      $header.removeClass();
    });

    windowWidth = window.innerWidth;

    if (windowWidth <= 767) {
      $mmCityRegion.insertAfter($navCityRegion);
      $mmExperience.insertAfter($navExperience);
      $mmTripPlanner.insertAfter($navTripPlanner);
    }
  });

  /** Window Load **/

  $(window).on('load', function () {
    // Resize Function

    navOffset = $header.offset().top;
    navHeight = $header.outerHeight();
  });

  /** Window Resize **/

  $(window).resize(function () {
    // Resize Function

    navOffset = $header.offset().top;
    navHeight = $header.outerHeight();
  });

  /** Window Scroll **/

  $(window).scroll(function () {

    var st = $(this).scrollTop();

    // Hide main nav once scrolled past its height
    if (st > navDelta + $('main').offset().top) {
      $('body').addClass('sticky-nav');
    }
    else if ($header.find(':focus').length === 0) {
      $('body').removeClass('sticky-nav');
    }

    if (Math.abs(lastScrollTop - st) <= navDelta) {
      return;
    }

    // If scrolling up reveal top nav
    if (st > lastScrollTop && $header.find(':focus').length === 0) {
      // Downscroll code if header isn't in focus
      $('body').removeClass('scroll-up');
    }
    else {
      // upscroll code
      $('body').addClass('scroll-up');
    }

    lastScrollTop = st;

  });

  /** Drupal Behaviors **/
  Drupal.behaviors.mainnav = {
    isTouchDevice: function () {
      return 'ontouchstart' in document.documentElement;
    },
    loadNavImgCity: function () {
      (new Image()).src = imgpath + 'nav-bg-memphis.jpg';
      (new Image()).src = imgpath + 'nav-bg-nashville.jpg';
      (new Image()).src = imgpath + 'nav-bg-jackson.jpg';
      (new Image()).src = imgpath + 'nav-bg-chattanooga.jpg';
      (new Image()).src = imgpath + 'nav-bg-knoxville.jpg';
      (new Image()).src = imgpath + 'nav-bg-pigeon-forge.jpg';
      (new Image()).src = imgpath + 'nav-bg-sevierville.jpg';
      (new Image()).src = imgpath + 'nav-bg-gatlinburg.jpg';
      (new Image()).src = imgpath + 'nav-bg-bristol.jpg';
      (new Image()).src = imgpath + 'nav-bg-bristol.jpg';
    },
    loadNavImgExp: function () {
      (new Image()).src = imgpath + 'nav-bg-road-trip.jpg';
      (new Image()).src = imgpath + 'nav-bg-outdoor-adventure.jpg';
      (new Image()).src = imgpath + 'nav-bg-outdoor-leisure.jpg';
      (new Image()).src = imgpath + 'nav-bg-celebrate.jpg';
      (new Image()).src = imgpath + 'nav-bg-family.jpg';
      (new Image()).src = imgpath + 'nav-bg-sports.jpg';
      (new Image()).src = imgpath + 'nav-bg-eat-drink.jpg';
      (new Image()).src = imgpath + 'nav-bg-history.jpg';
      (new Image()).src = imgpath + 'nav-bg-music.jpg';
    },
    loadNavImgPlan: function () {
      (new Image()).src = imgpath + 'nav-bg-eat-drink-planner.jpg';
      (new Image()).src = imgpath + 'nav-bg-do.jpg';
      (new Image()).src = imgpath + 'nav-bg-stay.jpg';
      (new Image()).src = imgpath + 'nav-bg-events.jpg';
      (new Image()).src = imgpath + 'nav-bg-road-trip.jpg';
      (new Image()).src = imgpath + 'nav-bg-inspiration.jpg';
      (new Image()).src = imgpath + 'nav-bg-music-pathways.png';
    },
    megaMenuActiveLink: function (item) {
      if ($header.hasClass('active-menu')) {
        $header.removeClass(function (index, className) {
          return (className.match(/(^|\s)active-item-\S+/g) || []).join(' ');
        });

        $header.addClass(item);
      }
    },
    megaMenuActiveParent: function (dataParent) {

      var activeParent = 'active-parent-' + dataParent;
      var activeBlock = '.block-' + dataParent;
      var thisClass = '.' + dataParent;

      if ($header.hasClass('active-menu')) {
        // Remove for reset of Item Class
        $header.removeClass(function (index, className) {
          return (className.match(/(^|\s)active-item-\S+/g) || []).join(' ');
        });

        // Remove for reset of Parent Class
        $header.removeClass(function (index, className) {
          return (className.match(/(^|\s)active-parent-\S+/g) || []).join(' ');
        });

        // Remove for reset of Active Block Class
        $(megaMenuBlock).removeClass('active-block').attr('aria-hidden', true);
        $topNavLinks.removeClass('active-nav');

        // BigPipe AJAX workaround
        if ($body.hasClass('user-logged-in')) {
          $('.block-mega-menu').removeClass('active-block').attr('aria-hidden', true);
        }

        $header.addClass(activeParent);
        $(activeBlock).addClass('active-block').attr('aria-hidden', false);
        if (!$(thisClass).parent().hasClass('menu-item__no-dropdown')) {
          $(thisClass).addClass('active-nav');
        }
      }
    },
    megaMenuClose: function () {
      $header.removeClass(function (index, className) {
        return (className.match(/(^|\s)active-\S+/g) || []).join(' ');
      });

      // Remove Active Block Class
      $(megaMenuBlock).removeClass('active-block').attr('aria-hidden', true);
      $topNavLinks.removeClass('active-nav');

      // BigPipe AJAX workaround
      if ($body.hasClass('user-logged-in')) {
        $('.block-mega-menu').removeClass('active-block').attr('aria-hidden', true);
      }
    },
    megaMenuOpen: function () {
      $header.addClass('active-menu');
    },
    topLevelHoverIn: function () {
      var dataParent = $.grep(this.className.split(' '), function (v, i) {
        return v.indexOf('nav') === 0;
      }).join();

      if (!$(this).hasClass('active-nav')) {
        Drupal.behaviors.mainnav.megaMenuOpen();
        Drupal.behaviors.mainnav.megaMenuActiveParent(dataParent);
      }
    },
    topLevelHoverOut: function () {
      // Empty function for hoverIntent
    },
    touchMenuClose: function () {
      $header.removeClass(function (index, className) {
        return (className.match(/(^|\s)active-\S+/g) || []).join(' ');
      });
      // Remove Active Block Class
      $header.removeClass('touch-main-menu-active');
      $header.removeClass('touch-menu-active');
      $header.removeClass('active-menu');
    },
    desktopAccessibility: function () {
      if (window.matchMedia('(min-width:1024px)').matches) {
        $($navToggle).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case enterKey:
                setTimeout(function () {
                  $('.nav-cities-regions').focus();
                }, 100);
                break;
            }
          }
        });
      }

      sessionStorage.removeItem('lastFocusedElement');

      if (window.matchMedia('(max-width: 767px)').matches) {
        if (!Drupal.behaviors.mainnav.isTouchDevice()) {
          Drupal.behaviors.mainnav.touchAccessibility();
        }
      }
      else {
        // Main Nav
        $mainLinks.each(function () {
          var $mainNavLink = $(this)['0'].classList['0'];
          var $mainNavBlock = $('.block-' + $mainNavLink);
          var $mainNavFirstLink = $($mainNavBlock).find('.js-mega-menu-link').first();
          var $mainNavTrigger = $(this).next('.menu-item__button');

          $(this).on('focus', function () {
            $($mainNavTrigger).addClass('focus');
            // Clear other Nav Triggers
            if (typeof sessionStorage.lastFocusedElement !== 'undefined') {
              $('.menu-item__button').not($mainNavTrigger).removeClass('focus');
            }
          });

          $($mainNavTrigger).on('blur', function () {
            sessionStorage.setItem('lastFocusedElement', $mainNavLink);
            if ($($mainNavBlock).hasClass('active-block')) {
              // do nothing
            }
            else {
              $($mainNavTrigger).removeClass('focus');
            }
          });

          $(this).on('keydown', function (e) {
            if ($(this).is(':focus')) {
              switch (e.key) {
                case tabKey:
                  if (e.shiftKey) {
                    $('.menu-item__button').removeClass('focus');
                  }
                  break;
              }
              return;
            }
          });

          // Main Nav Links
          $($mainNavTrigger).on('keydown', function (e) {
            if ($($mainNavTrigger).is(':focus')) {
              switch (e.key) {
                case enterKey:
                  if (!$(this).hasClass('active-nav')) {
                    $header.addClass('active-menu');
                    $(this).addClass('active-nav');
                    $($mainNavBlock).addClass('active-block').attr('aria-hidden', false);
                    $(this).attr('aria-expanded', true);
                    e.preventDefault();
                  }
                  else {
                    $header.removeClass('active-menu');
                    $(this).removeClass('active-nav').attr('aria-expanded', false);
                    $($mainNavBlock).removeClass('active-block').attr('aria-hidden', true);
                    e.preventDefault();
                  }
                  break;
                case tabKey:
                  if ($($header).hasClass('active-menu') && $($mainNavBlock).hasClass('active-block')) {
                    setTimeout(function () {
                      $($mainNavFirstLink).first().focus();
                    }, 100);
                    e.preventDefault();
                  }
                  break;
              }
              return;
            }
          });

        });
        $($megaMenuLink).on('keydown', function (e) {
          if ($(this).closest('.block-mega-menu').hasClass('active-block')) {
            var $activeMegaMenu = $(this).closest('.block-mega-menu');
            var $firstLink = $activeMegaMenu.find('.js-mega-menu-link').first();
            var $lastLink = $activeMegaMenu.find('.js-mega-menu-link').last();
            var $navID = '.' + $(this).closest('.block-mega-menu').data('nav-block');
            if ($(this)[0] === $firstLink[0] && $(this).is(':focus')) {
              switch (e.key) {
                case tabKey:
                  if (e.shiftKey) {
                    $($navID).next('.menu-item__button').focus().removeClass('active-nav').attr('aria-expanded', false);
                    $header.removeClass('active-menu');
                    $($activeMegaMenu).removeClass('active-block').attr('aria-hidden', true);
                    e.preventDefault();
                  }
                  else {
                    $(this).parent().next().find($megaMenuLink).focus();
                    e.preventDefault();
                  }
                  break;

              }
              return;
            }
            else if ($(this)[0] === $lastLink[0] && $(this).is(':focus')) {
              switch (e.key) {
                case tabKey:
                  if (e.shiftKey) {
                    return true;
                  }
                  else {
                    if ($(this).closest('.menu').next().hasClass('first')) {
                      $(this).closest('.menu').find('.region-map-link').first().focus();
                    }
                    else {
                      $($firstLink).focus();
                      e.preventDefault();
                    }
                  }
                  break;
              }
              return;
            }
          }
        });
        // City Nav Search Input
        var cityRegionSearchBar = $('.block-nav-cities-regions').find('.ui-autocomplete-input');
        $(cityRegionSearchBar).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if ($(this).val() === '') {
                  $('.block-nav-cities-regions').find('.js-mega-menu-link').first().focus();
                }
                e.preventDefault();
                break;
            }
            return;
          }
        });
        // Utility Nav
        $($utilityNav).find('a, button').each(function () {
          var $mainNavLink = $(this)['0'].classList['0'];
          var $mainNavBlock = $('.block-' + $mainNavLink);
          $(this).on('keydown', function (e) {
            if ($(this).hasClass('nav-search') && $(this).is(':focus')) {
              switch (e.key) {
                case enterKey:
                  $header.addClass('active-menu');
                  $(this).addClass('active-nav');
                  $($mainNavBlock).addClass('active-block').attr('aria-hidden', false);
                  setTimeout(function () {
                    $($mainNavBlock).find('.gsc-input').focus();
                  }, 100);
                  e.preventDefault();
                  break;
                case tabKey:
                  if (e.shiftKey) {
                    // Do nuthin'
                  }
                  else {
                    $firstFocusableContentElement.focus();
                    e.preventDefault();
                  }
                  break;
              }
              return;
            }
          });
        });
        $('.block-nav-search').on('keydown', '.gsc-input', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if ($(this).val() === '') {
                  $('.nav-search').removeClass('active-nav');
                  $header.removeClass('active-menu');
                  $('.block-nav-search').removeClass('active-block').attr('aria-hidden', true);
                }
                if (e.shiftKey) {
                  $('.nav-search').focus().removeClass('active-nav');
                  $header.removeClass('active-menu');
                  $('.block-nav-search').removeClass('active-block').attr('aria-hidden', true);
                  e.preventDefault();
                }
                break;
            }
            return;
          }
        });
        $firstFocusableContentElement.on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (e.shiftKey) {
                  $('.nav-search').focus().removeClass('active-nav');
                  $header.removeClass('active-menu');
                  $('.block-nav-search').removeClass('active-block').attr('aria-hidden', true);
                  e.preventDefault();
                }
                break;
            }
          }
        });
      }
    },
    touchAccessibility: function () {
      // Toggle Focus
      $navToggle.each(function () {
        $(once('mobile-toggle-keydown', $(this))).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (!$('#site-header').hasClass('active-menu')) {
                  $('#block-tnvacation-branding .site-logo').focus();
                  e.preventDefault();
                }
                break;
            }
          }
        });
      });
      // Logo Focus
      $('#block-tnvacation-branding .site-logo').each(function () {
        $(once('mobile-logo-keydown', $(this))).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (e.shiftKey) {
                  $('#nav-toggle').focus();
                }
                else {
                  $('.nav-my-trip').focus();
                }
                e.preventDefault();
                break;
            }
          }
        });
      });
      // Main Nav
      $mainLinks.each(function () {
        // Main Nav Links
        $(once('mainLinks-mobile-keydown', $(this))).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (e.shiftKey) {
                  if ($(this)['0'].classList['0'] === 'nav-cities-regions') {
                    $('#nav-toggle').focus();
                  }
                  else {
                    $(this).parent().prev().find('a').first().focus();
                  }
                  e.preventDefault();
                }
                else {
                  if ($(this)['0'].classList['0'] === 'link--calendar') {
                    $('#nav-toggle').focus();
                    e.preventDefault();
                  }
                  else {
                    if (!$(this).next().hasClass('active-block')) {
                      $(this).parent().next().find('a').first().focus();
                      e.preventDefault();
                    }
                  }
                }
                break;

              case enterKey:
                if (!Drupal.behaviors.mainnav.isTouchDevice()) {
                  if ($(this)['0'].classList['0'] === 'link--calendar') {
                    return true;
                  }
                  else {
                    if ($(this).closest('.menu-item').find('.block-mega-menu').hasClass('active-block')) {
                      $(this).closest('.menu-item').find('.block-mega-menu').removeClass('active-block').attr('aria-hidden', true);
                    }
                    else if (!$(this).closest('.menu-item').find('.block-mega-menu').hasClass('active-block')) {
                      $(this).closest('.menu-item').find('.block-mega-menu').addClass('active-block').attr('aria-hidden', false);
                    }

                    $('.menu-item').find('.block-mega-menu').not($(this).closest('.menu-item').find('.block-mega-menu')).removeClass('active-block').attr('aria-hidden', true);
                    e.preventDefault();
                  }
                }
                break;
            }
            return;
          }
        });

      });
    },
    searchBoxLabel: function () {
      var $searchBox = $('#block-megamenuforsearch input.gsc-input');
      var searchBoxId = $searchBox.attr('id');
      $searchBox.attr('placeholder', 'Search');
      $searchBox.before('<label for="' + searchBoxId + '" class="form-label-top">Search</label>');
    },
    attach: function (context, settings) {
      $(once('tnvacation_main_nav_functions', 'body', context)).each(function () {
        // Event when clicking Menu button
        $(once('menu', $navToggle)).on('click', function (e) {
          Drupal.behaviors.mainnav.megaMenuClose();

          if ($header.hasClass('touch-main-menu-active')) {
            Drupal.behaviors.mainnav.touchMenuClose();
            $('body').removeClass('main-menu-open');
          }
          else {
            $('body').addClass('main-menu-open');
            $header.addClass('touch-menu-active');
            $header.addClass('touch-main-menu-active');
            $header.addClass('active-menu');
          }

          e.preventDefault();
        });

        if (Drupal.behaviors.mainnav.isTouchDevice()) {
          Drupal.behaviors.mainnav.touchAccessibility();
          // Touch
          $body.addClass('touch');

          // Main menu on mobile.
          $(once('menu', $mainLinks)).on('click', function (e) {
            var dataParent = $.grep(this.className.split(' '), function (v, i) {
              return v.indexOf('nav') === 0;
            }).join();

            if (!$(this).hasClass('active-nav')) {
              Drupal.behaviors.mainnav.megaMenuOpen();
              Drupal.behaviors.mainnav.megaMenuActiveParent(dataParent);
              $header.addClass('touch-main-menu-active');
              $('.menu-item').find('.block-mega-menu').not($(this).closest('.menu-item').find('.block-mega-menu')).attr('aria-hidden', false);
            }
            else {
              if ($(this).closest('.menu-item').find('.block-mega-menu').hasClass('active-block')) {
                $(this).closest('.menu-item').find('.block-mega-menu').toggleClass('active-block').attr('aria-hidden', true);
              }
              else {
                $(this).closest('.menu-item').find('.block-mega-menu').toggleClass('active-block').attr('aria-hidden', false);
              }
            }

            e.preventDefault();
          });

          $(once('menu', $utilityLinks)).on('click', function (e) {
            var dataParent = $.grep(this.className.split(' '), function (v, i) {
              return v.indexOf('nav') === 0;
            }).join();

            if ($header.hasClass('touch-main-menu-active')) {
              $header.removeClass('touch-main-menu-active');
            }

            if (!$(this).hasClass('active-nav')) {
              Drupal.behaviors.mainnav.megaMenuOpen();
              Drupal.behaviors.mainnav.megaMenuActiveParent(dataParent);
            }
            else {
              Drupal.behaviors.mainnav.megaMenuClose();
              Drupal.behaviors.mainnav.touchMenuClose();
            }

            e.preventDefault();
          });
        }
        else {
          Drupal.behaviors.mainnav.desktopAccessibility();
          // Not Touch
          $navCityRegion.hoverIntent(Drupal.behaviors.mainnav.loadNavImgCity);
          $navExperience.hoverIntent(Drupal.behaviors.mainnav.loadNavImgExp);
          $navTripPlanner.hoverIntent(Drupal.behaviors.mainnav.loadNavImgPlan);

          $body.addClass('no-touch');

          $topNavLinks.hoverIntent(Drupal.behaviors.mainnav.topLevelHoverIn, Drupal.behaviors.mainnav.topLevelHoverOut);

          $mainNav.on('mouseenter', function (e) {
            navHover = true;
          });

          $utilityNav.on('mouseenter', function (e) {
            navHover = true;
          });

          $(megaMenuBlock).on('mouseenter', function (e) {
            megaMenuHover = true;
          });

          $utilityNav.on('mouseleave', function (e) {
            setTimeout(function () {
              if ($header.hasClass('active-menu') && (megaMenuHover === false) && ($header.find(':focus').length === 0)) {
                Drupal.behaviors.mainnav.megaMenuClose();
              }
            }, 100);
            navHover = false;
          });

          $mainNav.on('mouseleave', function (e) {
            setTimeout(function () {
              if ($header.hasClass('active-menu') && (megaMenuHover === false) && ($header.find(':focus').length === 0)) {
                Drupal.behaviors.mainnav.megaMenuClose();
              }
            }, 300);
            navHover = false;
          });

          $(megaMenuBlock).on('mouseleave', function (e) {
            if ($('.gssb_c').css('display') !== 'table') {
              if ($('.ui-autocomplete').css('display') !== 'block') {
                setTimeout(function () {
                  if ($header.hasClass('active-menu') && (navHover === false) && ($header.find(':focus').length === 0)) {
                    Drupal.behaviors.mainnav.megaMenuClose();
                  }
                }, 100);
              }
            }
            megaMenuHover = false;
          });

        }

        $megaMenuLink.on('mouseenter', function (e) {
          var dataItem = $(this).data('nav-item');
          var activeItem = 'active-item-' + dataItem;

          setTimeout(function () {
            Drupal.behaviors.mainnav.megaMenuActiveLink(activeItem);
          }, 100);
        });


        // Add search placeholder and label.
        if ($('#block-megamenuforsearch .gsc-input-box').length > 0) {
          Drupal.behaviors.mainnav.searchBoxLabel();
        }
        else {
          setTimeout(Drupal.behaviors.mainnav.searchBoxLabel, 1000);
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef

// # sourceMappingURL=maps/main-nav.js.map
